import { DocumentSettings } from "@models/document-settings"
import { Document } from "@models/document"
import { BreadCrumbData } from "@shared/lib/navigation/Breadcrumbs.types";



export function getLasAvailableBreadCrumb(breadcrumbData: BreadCrumbData[]): BreadCrumbData {
    
    for (let index = breadcrumbData.length-2; index >= 0; index--) {
        if(breadcrumbData[index].link){
            return breadcrumbData[index];
        }
    }

    throw new Error("available breadcrumb not found");
}


/**
 * Returns the last link available in breadcrumb data array.
 * @throws RangeError if link not found.
 */
export function getLastAvailableLink(breadcrumbData: BreadCrumbData[]): string {

    try {
        const availableBreadCrumb: BreadCrumbData = getLasAvailableBreadCrumb(breadcrumbData);
        return availableBreadCrumb.link!;
    } catch (error) {
        throw new Error("Last available Link not found");
    }

}


/**
 * get the path string, and return a BreadCrumbData.
 * if breadcrumbData from state exist, return it without doing anything.
 * @param pathname
 * @param documentSettings for /documents/add page
 * @param breadcrumbData - from store
 * @param document for /documents/:id page
 * @returns BreadCrumbData[]
 */
export function getBreadcrumbsData( pathname: string, documentSettings?: DocumentSettings, breadcrumbData?: BreadCrumbData[], document?: Document ): BreadCrumbData[] {

    if(breadcrumbData){
        return breadcrumbData;
    }

    switch (true) {
        case pathname === "/":
            return [
                {
                    name: "ראשי",
                }
            ];

        case pathname === "/documents":
            return [
                {
                    name: "מסמכים",
                }
            ];

        case pathname === "/documents/add":
            return [
                {
                    name: "מסמכים",
                    link: "/documents",
                    state: {}
                },
                {
                    name: "הוספת מסמך"
                },
                {
                    name: `${documentSettings?.name ?? ""}`,
                }
            ];

        case /^\/documents\/\d+\/?$/.test(pathname):
            return [
                {
                    name: "מסמכים",
                    link: "/documents"
                },
                {
                    name: `${document?.document_settings?.name ?? ""} ${document?.document_number ?? ""}`.trim(),
                }
            ];

        case pathname === "/documents/structure/browse":
            return [
                {
                    name: "מסמכים",
                    link: "/documents"
                },
                {
                    name: "הגדרת מבנה דפדוף מסמכים",
                }
            ];

        case pathname === "/documents/structure/account":
            return [
                {
                    name: "מסמכים",
                    link: "/documents"
                },
                {
                    name: "הוספת מסמך"
                },
                {
                    name: `${documentSettings?.name ?? ""}`,
                    link: `/documents/add?documentType=${documentSettings?.id}`
                },
                {
                    name: `הגדרת מבנה`
                },
                {
                    name: `לקוח/ספק`
                }
            ];

        case pathname === "/documents/structure/car":
            return [
                {
                    name: "מסמכים",
                    link: "/documents"
                },
                {
                    name: "הוספת מסמך"
                },
                {
                    name: `${documentSettings?.name ?? ""}`,
                    link: `/documents/add?documentType=${documentSettings?.id}`
                },
                {
                    name: `הגדרת מבנה`
                },
                {
                    name: `רכב`
                }
            ];

        case pathname === "/documents/structure/work":
            return [
                {
                    name: "מסמכים",
                    link: "/documents"
                },
                {
                    name: "הוספת מסמך"
                },
                {
                    name: `${documentSettings?.name ?? ""}`,
                    link: `/documents/add?documentType=${documentSettings?.id}`
                },
                {
                    name: `הגדרת מבנה`
                },
                {
                    name: `עבודה`
                }
            ];

        case pathname === "/documents/structure/item":
            return [
                {
                    name: "מסמכים",
                    link: "/documents"
                },
                {
                    name: "הוספת מסמך"
                },
                {
                    name: `${documentSettings?.name ?? ""}`,
                    link: `/documents/add?documentType=${documentSettings?.id}`
                },
                {
                    name: `הגדרת מבנה`
                },
                {
                    name: `פריט`
                }
            ];

        case pathname === "/tables":
            return [
                {
                    name: "טבלאות",
                }
            ];

        case pathname === "/reports":
            return [
                {
                    name: "דוחות",
                }
            ];

        case pathname === "/settings":
            return [
                {
                    name: "הגדרות",
                }
            ];

        case pathname === "/customers":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "לקוחות/ספקים",
                }
            ];

        case pathname === "/customers/add":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "לקוחות/ספקים",
                    link: "/customers"
                },
                {
                    name: "הוספת כרטיס",
                }
            ];

        case /^\/customers\/\d+\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "לקוחות/ספקים",
                    link: "/customers"
                },
                {
                    name: "עריכת כרטיס"
                }
            ];

        case /^\/customers\/\d+\/journal-entries\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "לקוחות/ספקים",
                    link: "/customers"
                },
                {
                    name: "הצגת תנועות"
                }
            ];

        case /^\/customers\/\d+\/history\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "לקוחות/ספקים",
                    link: "/customers"
                },
                {
                    name: "הצגת הסטוריה"
                }
            ];

        case pathname === "/items":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "פריטים/מלאי",
                }
            ];

        case pathname === "/items/add":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "פריטים/מלאי",
                    link: "/items"
                },
                {
                    name: "הוספת כרטיס",
                }
            ];

        case /^\/items\/\d+\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "פריטים/מלאי",
                    link: "/items"
                },
                {
                    name: "עריכת כרטיס"
                }
            ];

        case /^\/items\/\d+\/journal-entries\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "פריטים/מלאי",
                    link: "/items"
                },
                {
                    name: "הצגת תנועות"
                }
            ];


        case pathname === "/works":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "קודי עבודה",
                }
            ];

        case pathname === "/works/add":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "קודי עבודה",
                    link: "/works"
                },
                {
                    name: "הוספת כרטיס",
                }
            ];

        case /^\/works\/\d+\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "קודי עבודה",
                    link: "/works"
                },
                {
                    name: "עריכת כרטיס"
                }
            ];

        case pathname === "/cars":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "רכבים",
                }
            ];

        case pathname === "/cars/add":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "רכבים",
                    link: "/cars"
                },
                {
                    name: "הוספת כרטיס",
                }
            ];
            

        case /^\/cars\/\d+\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "רכבים",
                    link: "/cars"
                },
                {
                    name: "עריכת כרטיס"
                }
            ];


        case /^\/cars\/\d+\/journal-entries\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "רכבים",
                    link: "/cars"
                },
                {
                    name: "הצגת תנועות"
                }
            ];

        case pathname === "/incomes":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "הכנסות",
                }
            ];

        case pathname === "/incomes/add":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "הכנסות",
                    link: "/incomes"
                },
                {
                    name: "הוספת כרטיס",
                }
            ];

        case /^\/incomes\/\d+\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "הכנסות",
                    link: "/incomes"
                },
                {
                    name: "עריכת כרטיס"
                }
            ];


        case /^\/incomes\/\d+\/journal-entries\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "הכנסות",
                    link: "/incomes"
                },
                {
                    name: "הצגת תנועות"
                }
            ];

        case pathname === "/outcomes":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "הוצאות",
                }
            ];

        case pathname === "/outcomes/add":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "הוצאות",
                    link: "/outcomes"
                },
                {
                    name: "הוספת כרטיס",
                }
            ];

        case /^\/outcomes\/\d+\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "הוצאות",
                    link: "/outcomes"
                },
                {
                    name: "עריכת כרטיס"
                }
            ];


        case /^\/outcomes\/\d+\/journal-entries\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "הוצאות",
                    link: "/outcomes"
                },
                {
                    name: "הצגת תנועות"
                }
            ];

        case pathname === "/banks":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "בנקים",
                }
            ];

        case pathname === "/banks/add":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "בנקים",
                    link: "/banks"
                },
                {
                    name: "הוספת כרטיס",
                }
            ];

        case /^\/banks\/\d+\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "בנק",
                    link: "/banks"
                },
                {
                    name: "עריכת כרטיס"
                }
            ];


        case /^\/banks\/\d+\/journal-entries\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "בנק",
                    link: "/banks"
                },
                {
                    name: "הצגת תנועות"
                }
            ];

        case pathname === "/cash-boxes":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "קופה",
                }
            ];

        case pathname === "/cash-boxes/add":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "קופה",
                    link: "/cash-boxes"
                },
                {
                    name: "הוספת כרטיס",
                }
            ];

        case /^\/cash-boxes\/\d+\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "קופה",
                    link: "/cash-boxes"
                },
                {
                    name: "עריכת כרטיס"
                }
            ];


        case /^\/cash-boxes\/\d+\/journal-entries\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "קופה",
                    link: "/cash-boxes"
                },
                {
                    name: "הצגת תנועות"
                }
            ];

        case pathname === "/system":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "מערכת",
                }
            ];

        case pathname === "/system/add":
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "מערכת",
                    link: "/system"
                },
                {
                    name: "הוספת כרטיס",
                }
            ];

        case /^\/system\/\d+\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "מערכת",
                    link: "/system"
                },
                {
                    name: "עריכת כרטיס"
                }
            ];


        case /^\/system\/\d+\/journal-entries\/?$/.test(pathname):
            return [
                {
                    name: "כרטסות",
                },
                {
                    name: "מערכת",
                    link: "/system"
                },
                {
                    name: "הצגת תנועות"
                }
            ];

        default:
            return [];
    }

}


export function editLastBread(breadcrumbData: BreadCrumbData[] | undefined, link: string, state: any): BreadCrumbData[] | undefined {
    if(breadcrumbData && breadcrumbData?.length > 0){
        breadcrumbData[breadcrumbData.length-1].link = link;
        breadcrumbData[breadcrumbData.length-1].state = state;
    }

    return breadcrumbData;
}